export default __webpack_public_path__ + "static/media/LEXUS.a547390a.png";